import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import { translator } from "../../utils/i18n";
import Tooltip from "@material-ui/core/Tooltip";
import { useDispatch } from "react-redux";
import { switchWidgetAppointment } from "../../utils/fetcher";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.background.paper
    }
  },
  fab: {
    top: "-28px",
    right: 0,
    left: 0,
    position: "absolute",
    margin: "auto",
    background: "#009eff",
    color: "#fff"
  }
}));

export default function FooterPatientArea() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const switchToAppointment = () => dispatch(switchWidgetAppointment());

  const handleClick = () => {
    switchToAppointment();
  };

  return (
    <footer className="footer-patient-area">
      <Tooltip title={translator()._("CP_PRENDRE_RDV")} placement="top">
        <Fab color="primary" className={classes.fab} onClick={handleClick}>
          <AddIcon style={{ width: "2em", height: "2em" }} />
        </Fab>
      </Tooltip>
    </footer>
  );
}
